import React from 'react';
import Icon from '../../../components/AppIcon';

const ReviewsSection = () => {
  const reviews = [
    {
      id: 1,
      rating: 5,
      title: "Uneingeschränkte Empfehlung",
      content: `Ich möchte meine uneingeschränkte Empfehlung für die Rechtsanwaltskanzlei von Mirco Lehr, AdvoCall, in Berlin aussprechen. Herr Lehr hat mir in einer äußerst brenzligen Situation schnell und unkonventionell geholfen.\n\nDurch seine hervorragende Vertretung konnte er einen großen Schaden abwenden, der mir drohte.`,
      author: "Holger L.",
      location: "Frankfurt am Main",
      date: "1. Oktober 2024",
      category: "Rechtsberatung"
    },
    {
      id: 2,
      rating: 5,
      title: "Hervorragende Vertretung",
      content: `Herr Mirco Lehr hat mich in einer komplexen Angelegenheit hervorragend vertreten. Seine Fachkenntnis und sein Engagement sind beeindruckend.\n\nEr nahm sich stets Zeit für meine Fragen und erklärte alle rechtlichen Aspekte verständlich und klar.`,
      author: "Thorsten P.",
      location: "München",
      date: "30. September 2024",
      category: "Rechtsberatung"
    },
    {
      id: 3,
      rating: 5,
      title: "100% Empfehlung",
      content: `Ehrlich gesagt habe ich es genossen, mit ihnen zu arbeiten. Am Anfang habe ich mir den Kopf darüber zerbrochen, wie ich es schaffen werde.\n\nAber dann musste ich mich um fast nichts mehr kümmern und sie haben alles schnell und perfekt erledigt. Ehrlich gesagt, ich empfehle sie zu 100%.`,
      author: "Thierno B.",
      location: "Hamburg",
      date: "29. September 2024",
      category: "Rechtsberatung"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) =>
    <Icon
      key={index}
      name="Star"
      size={16}
      color={index < rating ? "#FCD34D" : "#E5E7EB"}
      className={index < rating ? "fill-current" : ""} />

    );
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Was unsere Mandanten sagen
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Echte Bewertungen von echten Menschen, die unsere telefonische Rechtsberatung in Anspruch genommen haben.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews?.map((review) => (
            <div
              key={review?.id}
              className="bg-white border border-slate-200 rounded-xl p-6 shadow-professional hover:shadow-elevated transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-1">
                  {renderStars(review?.rating)}
                </div>
                <span className="text-xs text-text-secondary bg-muted px-2 py-1 rounded-full">
                  {review?.category}
                </span>
              </div>

              <h3 className="font-semibold text-text-primary mb-3">
                {review?.title}
              </h3>

              <p className="text-text-secondary mb-4 leading-relaxed whitespace-pre-line">
                {review?.content}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                <div>
                  <p className="font-medium text-text-primary">{review?.author}</p>
                  <p className="text-sm text-text-secondary">{review?.location}</p>
                </div>
                <p className="text-sm text-text-secondary">{review?.date}</p>
              </div>
            </div>
          ))}
        </div>

        {/* More Reviews CTA */}
        <div className="text-center mt-12">
          <a
            href="https://share.google/Yt2vHpFVrRG2kQDu5"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-white border border-slate-200 rounded-lg text-text-secondary hover:text-primary hover:border-primary transition-all duration-200"
          >
            <Icon name="ExternalLink" size={18} />
            <span>Alle Bewertungen auf Google ansehen</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;